import React from "react"
import Icon from "components/elements/Icon"
import WhatsAppIcon from "components/elements/WhatsAppIcon"

type Props = {
  channel: "sms" | "whatsapp"
  size: number
}

const TextChannelIcon = ({ channel, size }: Props) => (
  channel === "whatsapp"
    ? <WhatsAppIcon size={size} color="whatsapp.500" />
    : <Icon icon="text-sms" size={size} color="blue.400" />
)

export default TextChannelIcon
